import angular from 'angular';
import "./ColumnResizer.scss";

const columnResizer = {
    bindings: {
        columnsWidth: '=',
        columnIndex: '<'
    },
    template: require('./column-resizer.html'),
    controller: function ($element, $document, $scope) {

        const MIN_COL_WIDTH = 1;
        const MAX_COL_WIDTH = 12;
        const RESIZE_LEFT_STEP = -1;
        const RESIZE_RIGHT_STEP = 1;
        const RESIZE_PENDING_SELECTOR = 'column-resize__pending';
        const RESIZE_PENDING_HANDLER  = 'column-resize__pending-handler';
        const ANIMATE_LEFT = 'animate-left';
        const ANIMATE_RIGHT = 'animate-right';

        let row = null;
        let rowWidth = null;
        let stepSize = null;
        let startPos = null;

        let colMinWidth = null;
        let colMaxWidth = null;

        let startWidth = null;

        this.$onInit = () => {
            $element.on('mousedown', startResizing);
        };

        /**
         * Compute start parameters of mouse move
         * Bind handlers
         * @param e
         */
        let startResizing = (e) => {
            row = $element.parent().parent()[0];
            rowWidth = row.offsetWidth;
            stepSize = rowWidth / 12;
            startPos = e.clientX;

            startWidth = currentColumnWidth();
            colMinWidth = calculateColumnMinWidth();
            colMaxWidth = calculateColumnMaxWidth();

            $(row).addClass(RESIZE_PENDING_SELECTOR);
            $element.addClass(RESIZE_PENDING_HANDLER);

            $document.on('mouseup', stopResizing);
            $document.on('mousemove', move);
        };

        /**
         * Clear handlers and classes at the end of action
         * @param e
         */
        let stopResizing = () => {
            $(row).removeClass(RESIZE_PENDING_SELECTOR);
            $element.removeClass(RESIZE_PENDING_HANDLER);

            $(row).removeClass(ANIMATE_LEFT);
            $(row).removeClass(ANIMATE_RIGHT);

            $document.off('mouseup', stopResizing);
            $document.off('mousemove', move);

            // Pass info to undo redo service
            if(startWidth !== currentColumnWidth()) {
                startWidth = currentColumnWidth();
                $scope.$emit('content-changed');
            }

        };

        /**
         * Fire on move
         * Detect if move left or right
         * @param e
         */
        let move = (e) => {

            let currentPos = e.clientX;

            if(startPos>currentPos) {
                $(row).removeClass(ANIMATE_RIGHT);
                $(row).addClass(ANIMATE_LEFT);
            } else if (startPos<currentPos) {

                $(row).removeClass(ANIMATE_LEFT);
                $(row).addClass(ANIMATE_RIGHT);
            }

            // If mouse moves 1/2 step distance
            if(startPos - currentPos > stepSize/2) {
                resizeColumn(RESIZE_LEFT_STEP);
            } else if(currentPos - startPos > stepSize/2) {
                resizeColumn(RESIZE_RIGHT_STEP);
            }

            e.preventDefault();
        };

        /**
         * Do actions to resize columns in view
         * @param changeValue
         */
        let resizeColumn = (changeValue) => {

            let newWidth = this.columnsWidth[this.columnIndex] + changeValue;

            if(!validateColumnWidth(newWidth)) {
                return;
            }

            recalculateStartDragPosition(changeValue);

            this.columnsWidth[this.columnIndex]   = newWidth;
            this.columnsWidth[this.columnIndex+1] = this.columnsWidth[this.columnIndex+1] - changeValue;

            $scope.$apply();
        };

        /**
         * Check if column width is inside min/max.
         * Min max is calculated on mousedown
         * @param newWidth
         * @returns {boolean}
         */
        let validateColumnWidth = (newWidth) => {
            return newWidth >= colMinWidth && newWidth <= colMaxWidth;
        };

        /**
         * Recalculate cursor "start position"
         * Used to detect if we move right or left in future
         * @param changeValue Value of step for example -1 for step left, +1 step right
         */
        let recalculateStartDragPosition = (changeValue) => {
            startPos += changeValue * stepSize;
        };

        /**
         * Calculate column width based on self width and right sibling width
         * @returns {number}
         */
        let calculateColumnMaxWidth = () => {
            if(this.columnsWidth.length > 1) {
                return this.columnsWidth[this.columnIndex] + this.columnsWidth[this.columnIndex +1] -1;
            }
            return MAX_COL_WIDTH;
        };

        /**
         * Return minimum column width
         * @returns {number}
         */
        let calculateColumnMinWidth = () => {
            return MIN_COL_WIDTH;
        };

        let currentColumnWidth = () => {
            return this.columnsWidth[this.columnIndex];
        }

    }
};

export default angular.module('cms.creator.column-resizer', [])
    .component('columnResizer', columnResizer).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Section/ColumnResizer/ColumnResizer.js